import { Grid } from "@mui/material";
import React from "react";
import FilterComponent from "./Components/FosMapping/FilterComponent";
import { useState } from "react";
import TableComponent from "./Components/FosMapping/TableComponent";
import BackdropLoader from "./Components/General/Loader";
import SnackBar from "./Components/General/SnackBar";
import { useEffect } from "react";
import { GetCspForFos, GetFosForDropdown } from "API/fos_mapping/api";



const FosMapping = () => {
    const [SelectedFos, setSelectedFos] = useState(null)
    const [FosName, setFosName] = useState(null)
    const [FosList, setFosList] = useState(null)
    const [AgentCode, setAgentCode] = useState(null)
    const [AgentType, setAgentType] = useState('unmapped')
    const [Searched, setSearched] = useState(false)

    const [IsLoading, setIsLoading] = useState(false);
    const [Alert, setAlert] = useState({
        open: false,
        message: "",
        type: "success"
    });
    const [Data, setData] = useState(null);


    const handleAlertOpen = (message, type) => {
        setAlert({
            open: true,
            message: message,
            type: type
        });
    }


    useEffect(() => {
        GetFosForDropdown(setFosList, setIsLoading, handleAlertOpen);
    }, [])


    const handleGet = () => {
        GetCspForFos(1, null, SelectedFos, AgentType, setData, setIsLoading, handleAlertOpen)
    }

    const HandleSearch = () => {
        GetCspForFos(1, AgentCode, SelectedFos, AgentType, setData, setIsLoading, handleAlertOpen)
        setSearched(true)
    }


    useEffect(() => {
        if (SelectedFos || AgentType === "unmapped") {
            GetCspForFos(1, null, SelectedFos, AgentType, setData, setIsLoading, handleAlertOpen)
        }
    }, [SelectedFos, AgentType])




    const handleAlertClose = () => {
        setAlert(((prevData => {
            return {
                ...prevData,
                open: false,
            };
        })));
    }


    const handlePageChange = (event, value) => {
        if (SelectedFos || AgentType === 'unmapped') {
            GetCspForFos(value + 1, null, SelectedFos, AgentType, setData, setIsLoading, handleAlertOpen)
        }
    }

    const handleChange = (name, value) => {
        if (name === "fos") {
            setSelectedFos(value)
            setFosName(FosList.find((item) => item._id === value)?.username)
            setData(null)
        }
        else if (name === "csp_type") {
            setAgentType(value)
        }
        else {
            if(/^[0-9a-zA-Z]*$/.test(value)){
                setAgentCode(value.toUpperCase())
            }
        }
    }

    const handleClear = () => {
        setAgentCode(null)
        setSelectedFos(null)
        setFosName(null)
        setAgentType("unmapped")
       
        setSearched(false)
    }


    console.log("SelectedFos", setFosList);



    return (
        <Grid container spacing={2} justifyContent="center" alignItems="center">
            <BackdropLoader open={IsLoading} />
            <SnackBar open={Alert.open} type={Alert.type} message={Alert.message} handleClose={handleAlertClose} />
            <Grid item xs={12}>
                <FilterComponent searched={Searched} fos={SelectedFos} handleChange={handleChange} data={FosList} agentCode={AgentCode} handleClear={handleClear} handleSearch={HandleSearch} />
                <TableComponent fos={SelectedFos} fosName={FosName} data={Data} agent_type={AgentType} handleChange={handleChange} handlePageChange={handlePageChange} setIsLoading={setIsLoading} handleAlertOpen={handleAlertOpen} handleGet={handleGet} />
            </Grid>
        </Grid>
    );
}



export default FosMapping;